import Iconify from 'src/components/iconify';

export const BoardAvatar = ({
  emoji,
  icon = 'tabler:table',
  iconColor = 'inherit',
}: {
  emoji?: string;
  icon?: string;
  iconColor?: string;
}) => {
  if (emoji) return <em-emoji shortcodes={emoji} />;
  return <Iconify icon={icon} color={iconColor} flexShrink={0} />;
};
